export class FreemiumConstants {
  static REDIRECT_SOURCES = {
    JOB_DESCRIPTION: "job_description",
    QUICK_SEARCH: "quick_search"
  }
}

export class LoaderType {
  static LODER_TYPE = {
    STATS :"stats",
    RECOMMENDED_CANDIDATE: "recommended-candidate",
  }

}
